
export interface SubMenu {
    title: string
    logo: string
    items: SubMenuItem[]
}

export interface SubMenuItem {
    title: string
    selected: boolean
    href: string
}

export enum tabTypes {
    discover = 'discover',
    integrate = 'integrate',
    installed = 'installed',
    updates = 'updates'
}
